module.exports = __webpack_public_path__ + "files/a2e0518998813700c25dace9131d8b6c.png";